<template>
    <div id="`eissublist`">
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>

<script>
import moment from 'moment';


import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('claimrecordlisting.claimrecordlist'),
            dataHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '80px', sortable: false},
                { text: this.$t('columns.staffid'), value: 'staffno', width: '100px'},
                { text: this.$t('columns.name'), value: 'staffname', width: '200px' },
                { text: this.$t('attendancereportbypeiordbycompanyreport.companyname'), value: 'compnyname', width: '90px' },
                { text: this.$t('claimreport.claimtype'), value: 'clmtype', width: '100px' },
                { text: this.$t('claimrecordlisting.entrydate'), value: 'entrytime', width: '200px' },
    
            ],

            dataItems: [],
            loading: false,
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        getThisListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: '/claimrecord/all'})
                .then(function (res) {
                    for (let i = 0; i < res.data.rec.length; i++) {
                        if (res.data.rec[i].entrytime) {
                            res.data.rec[i].entrytime = moment(res.data.rec[i].entrytime).format('YYYY-MM-DD');
                        }

                        if (res.data.rec[i].draft == 'N') {
                            vm.dataItems.push(res.data.rec[i])
                        }
                    }

                    vm.loading = !vm.loading;
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        editItemHandler(item) {
            this.$router.push({name: 'claimrecordedit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'claimrecordnew'});
        }
    },

    mounted() {
        this.getThisListHandler();
    }
}
</script>